import { AuthUser } from 'app/provider/auth'
import { GroupPostCreationModal } from '../group-post-creation-modal'
import { GroupEvent } from 'app/types'
import { EventCreationView, EventFormData, SubmitEventData } from './event-creation-view'
import { format } from 'date-fns'

export interface GroupEventEditWizardProps {
  open: boolean
  user: Pick<AuthUser, 'id' | 'fullName' | 'avatar' | 'token'>
  event: GroupEvent
  submitting: boolean
  onOpenChange: (value) => void
  onSubmit: (data: SubmitEventData) => void
}

export const GroupEventEditWizard = (props: GroupEventEditWizardProps) => {
  const { event } = props

  const defaultValues: EventFormData = {
    name: event.name,
    description: event.description,
    location: event.location,
    startDate: format(new Date(event.startDate), 'yyyy-MM-dd'),
    startTime: format(new Date(event.startDate), 'HH:mm'),
    ...(event.endDate && {
      endDate: format(new Date(event.endDate), 'yyyy-MM-dd'),
      endTime: format(new Date(event.endDate), 'HH:mm'),
    }),
  }

  return (
    <GroupPostCreationModal key="Edit modal" open={props.open} onOpenChange={props.onOpenChange}>
      <EventCreationView
        title="Edit event"
        user={props.user}
        onOpenChange={props.onOpenChange}
        onSubmit={props.onSubmit}
        isSubmitting={props.submitting}
        defaultValues={defaultValues}
        defaultImage={event.image?.url}
        selectedGroup={event.group}
        isEditing
      />
    </GroupPostCreationModal>
  )
}
